import React, { useState } from 'react';
import {
  CompanyInfoElements,
  CompanyInformationContainer,
} from '../../ResultPageComponents/v2/RiskCard.styles';
import infoIcon from '../../../../../assets/redesign_icons/info-icon.svg';
import { downloadResourceDocs } from '../../../../../services/axios-client/axeCommons';
import preContractIcon from '../../../../../assets/redesign_icons/pre-contract-icon.svg';
import MyRescueInfoModal, { MY_RESCUE_INFO } from '../../Modal/MyRescueInfoModal';
import SaluteInfoModal from '../../Modal/SaluteInfoModal';
import { saluteInfo } from '../../../../constants';

// Informativa Precontrattuale document ids (My Rescue, company_id 1005)
const MY_RESCUE_DOC_IDS = {
  tutela_legale: 60,
  collisione: 61,
  assistenza_stradale: 62,
};

// Informativa Precontrattuale document ids — one per company, regardless of
// risk type (Global Assistance / Europe Assistance)
const PRECONTRACT_DOC_IDS = {
  16: 13, // Global Assistance
  8: 14, // Europe Assistance
};

// Salute (Europe Assistance, product 12) risks that have an info modal: every
// saluteInfo entry except res_civile (the main quote, shown by the quote card)
const SALUTE_INFO_QUOTE_TYPES = saluteInfo
  .map((info) => info.quote_type)
  .filter((quoteType) => quoteType !== 'res_civile');

function PrecontractInfoLink({ companyId }) {
  const docId = PRECONTRACT_DOC_IDS[companyId];
  if (!docId) return null;

  return (
    <CompanyInfoElements
      onClick={() => downloadResourceDocs(docId, 0)}
      title="Informativa Precontrattuale"
    >
      <img src={preContractIcon} alt="" />
      <p>
        Informativa Precontrattuale
      </p>
    </CompanyInfoElements>
  );
}

function RiskCompanyInfoComponent({ quote, openModal, openModalEurope }) {
  const [showModalMyRescue, setShowModalMyRescue] = useState(false);
  const [showModalSalute, setShowModalSalute] = useState(false);

  return (
    <>
      {quote.quote_type === 'assistenza_stradale'
        && quote.company_id === 16 && (
          <CompanyInformationContainer>
            <CompanyInfoElements onClick={() => openModal()}>
              <img src={infoIcon} alt="" />
              <p>Maggiori Informazioni</p>
            </CompanyInfoElements>
            <PrecontractInfoLink companyId={quote.company_id} />
          </CompanyInformationContainer>
      )}
      {quote.quote_type === 'assistenza_stradale' && quote.company_id === 8 && (
        <CompanyInformationContainer>
          <CompanyInfoElements onClick={() => openModalEurope()}>
            <img src={infoIcon} alt="" />
            <p>Maggiori Informazioni</p>
          </CompanyInfoElements>
          <PrecontractInfoLink companyId={quote.company_id} />
        </CompanyInformationContainer>
      )}
      {quote.quote_type === 'tutela_legale'
        && quote.company_id === 16
        && quote.product_id !== 10 && (
          <CompanyInformationContainer>
            <CompanyInfoElements onClick={() => openModal()}>
              <img src={infoIcon} alt="" />
              <p>Maggiori Informazioni</p>
            </CompanyInfoElements>
            <PrecontractInfoLink companyId={quote.company_id} />
          </CompanyInformationContainer>
      )}
      {quote.quote_type === 'tutela_legale' && quote.company_id === 8 && (
        <CompanyInformationContainer>
          <CompanyInfoElements onClick={() => openModalEurope()}>
            <img src={infoIcon} alt="" />
            <p>Maggiori Informazioni</p>
          </CompanyInfoElements>
          <PrecontractInfoLink companyId={quote.company_id} />
        </CompanyInformationContainer>
      )}
      {quote.quote_type === 'tutela_legale'
        && quote.company_id === 15
        && quote.information && (
          <CompanyInformationContainer>
            <CompanyInfoElements onClick={() => openModal()}>
              <img src={infoIcon} alt="" />
              <p>Maggiori informazioni</p>
            </CompanyInfoElements>
          </CompanyInformationContainer>
      )}
      {quote.quote_type === 'infortuni_conducente'
        && quote.company_id === 16 && (
          <CompanyInformationContainer>
            <CompanyInfoElements onClick={() => openModal()}>
              <img src={infoIcon} alt="" />
              <p>Maggiori Informazioni</p>
            </CompanyInfoElements>
            <PrecontractInfoLink companyId={quote.company_id} />
          </CompanyInformationContainer>
      )}
      {quote.quote_type === 'cristalli' && quote.company_id === 16 && (
        <CompanyInformationContainer>
          <CompanyInfoElements onClick={() => openModal()}>
            <img src={infoIcon} alt="" />
            <p>Maggiori Informazioni</p>
          </CompanyInfoElements>
          <PrecontractInfoLink companyId={quote.company_id} />
        </CompanyInformationContainer>
      )}
      {quote.quote_type === 'cristalli' && quote.company_id === 8 && (
        <CompanyInformationContainer>
          <CompanyInfoElements onClick={() => openModalEurope()}>
            <img src={infoIcon} alt="" />
            <p>Maggiori Informazioni</p>
          </CompanyInfoElements>
          <PrecontractInfoLink companyId={quote.company_id} />
        </CompanyInformationContainer>
      )}
      {quote.quote_type === 'collisione' && quote.company_id === 8 && (
        <CompanyInformationContainer>
          <CompanyInfoElements onClick={() => openModalEurope()}>
            <img src={infoIcon} alt="" />
            <p>Maggiori Informazioni</p>
          </CompanyInfoElements>
          <PrecontractInfoLink companyId={quote.company_id} />
        </CompanyInformationContainer>
      )}

      {/* {quote.quote_type === 'invalidita_permanente_da_infortunio' && quote.product_id === 1002 && (
      <CompanyInformationContainer>
        <CompanyInfoElements onClick={() => openModal()}>
          <img src={infoIcon} alt="" />
          <p>Maggiori Informazioni</p>
        </CompanyInfoElements>
      </CompanyInformationContainer>
      )} */}
      {quote.sub_product === 'vita_privata' && quote.company_id === 16 && quote.product_id === 9 && (
        <CompanyInformationContainer>
          <CompanyInfoElements onClick={() => openModal()}>
            <img src={infoIcon} alt="" />
            <p>Maggiori Informazioni</p>
          </CompanyInfoElements>
        </CompanyInformationContainer>
      )}

      {quote.company_id === 1005 && quote.product_id === 1
        && (MY_RESCUE_INFO[quote.quote_type] || MY_RESCUE_DOC_IDS[quote.quote_type]) && (
          <CompanyInformationContainer>
            {MY_RESCUE_INFO[quote.quote_type] && (
              <CompanyInfoElements onClick={() => setShowModalMyRescue(true)}>
                <img src={infoIcon} alt="" />
                <p>Maggiori Informazioni</p>
              </CompanyInfoElements>
            )}
            {MY_RESCUE_DOC_IDS[quote.quote_type] && (
              <CompanyInfoElements
                onClick={() => downloadResourceDocs(MY_RESCUE_DOC_IDS[quote.quote_type], 0)}
                title="Informativa Precontrattuale"
              >
                <img src={preContractIcon} alt="" />
                <p>
                  Informativa Precontrattuale
                </p>
              </CompanyInfoElements>
            )}
          </CompanyInformationContainer>
      )}
      {showModalMyRescue && (
        <MyRescueInfoModal
          quoteType={quote.quote_type}
          setShowModal={setShowModalMyRescue}
        />
      )}

      {quote.company_id === 8 && quote.product_id === 12
        && SALUTE_INFO_QUOTE_TYPES.includes(quote.quote_type) && (
          <CompanyInformationContainer>
            <CompanyInfoElements onClick={() => setShowModalSalute(true)}>
              <img src={infoIcon} alt="" />
              <p>Maggiori Informazioni</p>
            </CompanyInfoElements>
          </CompanyInformationContainer>
      )}
      {showModalSalute && (
        <SaluteInfoModal quote={quote} setShowModal={setShowModalSalute} />
      )}

      {quote.quote_type !== 'res_civile' && quote.company_id === 1001 && quote.product_id === 1 && (
        <CompanyInformationContainer>
          <CompanyInfoElements
            onClick={() => downloadResourceDocs(55, 0)}
            title="Informativa Precontrattuale"
          >
            <img src={preContractIcon} alt="" />
            <p>
              Informativa Precontrattuale
            </p>
          </CompanyInfoElements>
        </CompanyInformationContainer>
      )}

    </>
  );
}

export default RiskCompanyInfoComponent;
